// Stream handles message insertion, but not every late resize (receipts,
// attachments, fonts, or the composer changing the available list height).
export const observeMessageListSize = (list, scrollToBottom) => {
  if (!list || typeof ResizeObserver === "undefined") return () => {};
  const atBottom = () => list.scrollHeight - list.clientHeight - list.scrollTop <= 2;
  let pinned = atBottom();
  let height = list.clientHeight;
  let contentHeight = list.scrollHeight;
  let scrollTop = list.scrollTop;
  const updatePosition = () => {
    // A layout change can itself dispatch scroll before ResizeObserver runs.
    // Allow the browser to clamp the old position when content shrinks, but
    // honor movement above that position (including native scrollbar input).
    const clampedTop = Math.min(scrollTop, Math.max(0, list.scrollHeight - list.clientHeight));
    // Reaching the bottom always restores following, even during a resize.
    if (atBottom() ||
        (height === list.clientHeight && contentHeight === list.scrollHeight) ||
        list.scrollTop < clampedTop - 2) {
      pinned = atBottom();
    }
    scrollTop = list.scrollTop;
  };
  const observer = new ResizeObserver(() => {
    // Read position here too: a real scroll may precede its scroll event.
    updatePosition();
    const resized = height !== list.clientHeight || contentHeight !== list.scrollHeight;
    if (resized && pinned) scrollToBottom();
    height = list.clientHeight;
    contentHeight = list.scrollHeight;
    scrollTop = list.scrollTop;
  });
  const observeContent = () => {
    observer.disconnect();
    observer.observe(list);
    // Includes the typing indicator; also handles the empty-list placeholder.
    Array.from(list.children).forEach((child) => observer.observe(child));
  };
  const mutations = new MutationObserver(observeContent);
  mutations.observe(list, { childList: true });
  observeContent();
  list.addEventListener("scroll", updatePosition, { passive: true });
  return () => {
    observer.disconnect();
    mutations.disconnect();
    list.removeEventListener("scroll", updatePosition);
  };
};
